import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

/**
 * Loader Component
 * Full-screen loading overlay with spinner and app icon
 * Refactored with Tailwind CSS
 * 
 * @component
 * @param {boolean} loading - Whether to show the loader
 */
const Loader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white/30 z-[998]">
      <div className="absolute top-[41%] left-[38%]">
        <img
          src="/images/AppIcon_64x64.png"
          alt="Loading"
          className="absolute w-12 top-[17px] left-[21px] z-10"
        />
        <ClipLoader
          loading={loading}
          size={90}
          color="#3901ff"
        />
      </div>
    </div>
  );
};

export default Loader;
